<theme-root *ngIf="show" [buildNumber]="buildNumber">
    <app-context-toolbar></app-context-toolbar>
</theme-root>
